import { networkService as network } from '@/services'

export const userEventsService = {

  getUserEventsAll(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/user-events/all/user/${id}`)
        .then((data) => {
          resolve(data.data)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getUserEventsAllByEvent(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/user-events/all/event/${id}`)
        .then((data) => {
          resolve(data.data)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  createUserEvent({user, event, status}) {
    return new Promise((resolve, reject) => {
      const request = {user, event, status}
      network
        .post(`/user-events`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },



  updateUserEvent({ id, user, event, status}) {
    return new Promise((resolve, reject) => {
      const request = { id, user, event, status}
      network
        .put(`/user-events/${id}`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  deleteUserEvent(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/user-events/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

}